import { hasSelectAnswer } from "./selectDependencies";
import { getValueByPath, walkQuestionTree } from "./questionTree";

function getSourceQuestionByRadioGroup(questions, radioGroup) {
  if (!questions || !radioGroup) return null;

  const sourceQuestion = questions.find(
    (question) => question.radioGroup === radioGroup
  );
  if (sourceQuestion) return sourceQuestion;

  for (const question of questions) {
    let source;
    walkQuestionTree(question, (node) => {
      if (!source && node.radioGroup === radioGroup) source = node;
    });
    if (source) return source;
  }

  return null;
}

function getSelectItems(question) {
  if (!question || !Array.isArray(question.questions)) return [];

  if (question.type === "text") {
    return question.questions;
  }

  if (question.type === "select") {
    return question.questions.reduce((items, selectQuestion) => {
      if (Array.isArray(selectQuestion.options)) {
        return items.concat(selectQuestion.options);
      }

      return items;
    }, []);
  }

  return [];
}

function clearSelectItemAnswer(item) {
  item.answer = "";
}

function clearDefaultSelectItemAnswer(item) {
  if (item.defaultVal !== undefined && item.answer === item.defaultVal) {
    item.answer = "";
  }
}

function setSelectItemDefaultAnswer(item) {
  if (item.defaultVal !== undefined) {
    item.answer = item.defaultVal;
  }
}

function applySelectControlMode(question, mode, sourceAnswer) {
  const selectItems = getSelectItems(question);
  const shouldApplyTransition =
    question.controlledSelectLastSourceAnswer !== sourceAnswer;

  question.show = mode.show !== false;
  question.controlledSelectNote = mode.note || "";
  question.controlledSelectLastSourceAnswer = sourceAnswer;

  selectItems.forEach((item) => {
    item.disabled = !!mode.disabled;

    if (mode.placeholder) {
      item.placeholder = mode.placeholder;
    }

    if (mode.useDefaultAnswers) {
      setSelectItemDefaultAnswer(item);
      return;
    }

    if (mode.clearAnswers) {
      clearSelectItemAnswer(item);
      return;
    }

    if (mode.clearDefaultAnswers && shouldApplyTransition) {
      clearDefaultSelectItemAnswer(item);
    }
  });
}

export function syncControlledSelectQuestions(questions) {
  if (!questions || !questions.length) return questions;

  questions.forEach((question) => {
    const control = question.controlledSelect;
    if (!control || !control.sourceRadioGroup || !control.modes) return;

    const sourceQuestion = getSourceQuestionByRadioGroup(
      questions,
      control.sourceRadioGroup
    );
    const sourceAnswer = getValueByPath(
      sourceQuestion,
      control.sourceAnswerField || "answer"
    );
    const mode = control.modes[sourceAnswer] || control.defaultMode;

    if (!mode) return;
    applySelectControlMode(question, mode, sourceAnswer);
  });

  return questions;
}

export function isControlledSelectQuestionComplete(question) {
  if (!question || !question.controlledSelect || question.show === false) {
    return true;
  }

  return getSelectItems(question)
    .filter((item) => item.optional !== true)
    .every((item) => hasSelectAnswer(item.answer));
}
